import React from 'react';
import Button from 'react-bootstrap/Button';
import { FormattedMessage } from 'react-intl';
import PropdocsModal from '../../../../../modal/PropdocsModal';
import { OptionalMessageInputRef } from '../../../../document-wizard-modal/custom-modals/document-wizard-action-modal/OptionalMessageInputRef';

interface ConfirmReadyToSignModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (message: string) => void;
  creatorTeamName?: string;
  isSubmitting: boolean;
}

const ConfirmReadyToSignModal = ({
  isOpen,
  onClose,
  onConfirm,
  creatorTeamName,
  isSubmitting,
}: ConfirmReadyToSignModalProps) => {
  const optionalMessageInputRef = React.useRef<HTMLTextAreaElement>(null);

  const handleConfirm = () => {
    const message = optionalMessageInputRef.current?.value || '';
    onConfirm(message);
  };

  return (
    <PropdocsModal
      show={isOpen}
      setShow={onClose}
      size="md"
      title={
        <header>
          <FormattedMessage id="ready-to-sign.title" defaultMessage="Ready to Send for Signing?" />
        </header>
      }
    >
      <>
        <div style={{ marginBottom: '1rem' }}>
          <p>
            {creatorTeamName ? (
              <FormattedMessage
                id="ready-to-sign.description"
                defaultMessage="This will notify {creatorTeamName} that you've reviewed the document and it's ready for signature preparation."
                values={{ creatorTeamName }}
              />
            ) : (
              <FormattedMessage
                id="ready-to-sign.description-generic"
                defaultMessage="This will notify the document creator that you've reviewed the document and it's ready for signature preparation."
              />
            )}
          </p>
        </div>

        <OptionalMessageInputRef ref={optionalMessageInputRef} />

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1.5rem' }}>
          <Button variant="link" className="text-secondary" onClick={onClose} disabled={isSubmitting}>
            <FormattedMessage id="cta.cancel" defaultMessage="Cancel" />
          </Button>
          <Button variant="secondary" onClick={handleConfirm} disabled={isSubmitting}>
            <FormattedMessage id="ready-to-sign.confirm" defaultMessage="Confirm Ready to Sign" />
          </Button>
        </div>
      </>
    </PropdocsModal>
  );
};

export default ConfirmReadyToSignModal;
